import { FeaturesPutReleaseByKeyResponse } from '@flowio/api-internal-sdk';
import { RootActionTypes, ThunkResult } from '../../../stores/types';
import formatErrorResponseV2, { FormattedErrorMessages } from '../../../utilities/format-error-response-v2';
import ActionTypes from '../constants/action-types';

function createRequestAction(organizationId: string, featureKey: string): RootActionTypes {
  return {
    type: ActionTypes.RELEASE_FEATURE_BY_KEY_REQUEST,
    meta: {
      organizationId,
      featureKey,
    },
  };
}

function createSuccessAction(
  organizationId: string,
  featureKey: string,
  payload: io.flow.internal.v0.models.Feature,
): RootActionTypes {
  return {
    type: ActionTypes.RELEASE_FEATURE_BY_KEY_SUCCESS,
    meta: {
      organizationId,
      featureKey,
    },
    payload,
  };
}

function createFailureAction(
  organizationId: string,
  featureKey: string,
  payload: FormattedErrorMessages,
): RootActionTypes {
  return {
    type: ActionTypes.RELEASE_FEATURE_BY_KEY_FAILURE,
    meta: {
      organizationId,
      featureKey,
    },
    payload,
  };
}

export default function deleteFeatureByKey(
  organizationId: string,
  featureKey: string,
): ThunkResult<Promise<FeaturesPutReleaseByKeyResponse>> {
  return function deleteFeatureByKeyEffect(
    dispatch,
    getState,
    extra,
  ): Promise<FeaturesPutReleaseByKeyResponse> {
    dispatch(createRequestAction(organizationId, featureKey));

    return extra.apiInternal(getState()).features.putReleaseByKey({
      key: featureKey,
      organization: organizationId,
      body: {},
    }).then((response) => {
      if (response.ok) {
        dispatch(createSuccessAction(organizationId, featureKey, response.body));
        return response;
      }

      const error = formatErrorResponseV2(response);
      dispatch(createFailureAction(organizationId, featureKey, error));
      return response;
    });
  };
}
